// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__7m6wp","description":"PatientConsentPreview_description__1eZJi"};